var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 30,
    fill: "#00A6A6",
    stroke: "white",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38 30C38 33.87 34.64 37 30.5 37L29.57 38.12L29.02 38.78C28.55 39.34 27.65 39.22 27.34 38.55L26 35.6C24.18 34.32 23 32.29 23 30C23 26.13 26.36 23 30.5 23C33.52 23 36.13 24.67 37.3 27.07C37.75 27.96 38 28.95 38 30Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0003 33.86C43.0003 36.15 41.8203 38.18 40.0003 39.46L38.6603 42.41C38.3503 43.08 37.4503 43.21 36.9803 42.64L35.5003 40.86C33.0803 40.86 30.9203 39.79 29.5703 38.12L30.5003 37C34.6403 37 38.0003 33.87 38.0003 30C38.0003 28.95 37.7503 27.96 37.3003 27.07C40.5703 27.82 43.0003 30.58 43.0003 33.86Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30.75H28C27.59 30.75 27.25 30.41 27.25 30C27.25 29.59 27.59 29.25 28 29.25H33C33.41 29.25 33.75 29.59 33.75 30C33.75 30.41 33.41 30.75 33 30.75Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.b0122efd1d147076c6d0fcd1684eb6c4.svg";
export { ForwardRef as ReactComponent };